<template>
  <v-container fluid class="icons-page">
    <v-row no-gutters class="d-flex justify-space-between mt-2 mb-2">
      <v-col>
        <!-- List -->
        <Table
          newItemLabel="All Universities Orders"
          :filter="filter"
          :title="title"
          :api="api"
          :create="create"
          :pay="pay"
          :block ="block"
          :edit = "edit"
          :del="del"
          :recovery_update_order="recovery_update_order"
          :headers="headers"
          @openForm="setForm"
          @openFormPay="setFormPay"
          @update_page="
            (val) => {
              page = val;
            }
          "
        ></Table>
        <!-- Form -->
      </v-col>
    </v-row>
    <v-dialog v-model="dialog_pay_form" max-width="450px">
      <ConfirmPayFormUniversite
        v-if="dialog_pay_form"
        newItemLabel="Confirm Paying"
        :isNew="isNew"
        :api="api"
        :page="page"
        @dialogForm="dialog_pay_form = false"
      ></ConfirmPayFormUniversite>
    </v-dialog>

    <v-dialog v-model="dialog_form" max-width="500px">
      <GeneralForm
        v-if="dialog_form"
        :fields="fields"
        newItemLabel="Add Notes"
        :isNew="isNew"
        :api="api"
        @dialogForm="dialog_form = false"
      ></GeneralForm>
    </v-dialog>
  </v-container>
</template>

<script>

export default {
  data() {
    return {
      isNew: true,
      dialog_form: false,
      dialog_pay_form: false,
      page: 1,
      recovery_update_order:false,

      api: {
        getAll: "islamic_bank_payment_orders",
        filter: "islamic_bank_payment_orders",
        pay: "islamic_bank_payment/make-payed",
        type:"Islamic_bank_payment",
        recovery_update_order:"recovery_update_bill",

      },
      fields: [
        {
          name: "notes",
          key: "notes",
        },
      ],
      pay: true,
      create: false,
      del: false,
      edit: false,
      filter: "universities",
      title: "All Universities Orders",
      block:false,
      headers: [
        {
          text: "#",
          align: "start",
          sortable: true,
          value: "id",
        },
        {
          text: "",
          value: "actions",
          sortable: false,
        },
        {
          text: "customer id",
          value: "customer_id",
        },
        {
          text: "University",
          value: "university.name",
        },
        {
          text: "response",
          value: "response_relation.result",
        },
        {
          text: "status",
          value: "status",
        },
        {
          text: "payment method",
          value: "payment_method",
        },
        {
          text: "student_name",
          value: "student_name",
        },
        {
          text: "amount",
          value: "amount",
        },
        {
          text: "amount_SYP",
          value: "amount_SYP",
        },
        {
          text: "currency",
          value: "currency",
        },
        {
          text: "year",
          value: "year",
        },
        {
          text: "date",
          value: "created_at",
        },
      ],
    };
  },
  methods: {
    setForm(val) {
      console.log(val);
      let form = {
        id: null,
        notes: null,
      };
      this.$store.dispatch("initForm", form);
      if (val != null) {
        this.isNew = false;
        this.$store.dispatch("setForm", val);
      } else {
        this.isNew = true;
      }
      this.dialog_form = true;
    },
    setFormPay(val) {
      console.log(val);
      let form = {
        id: null,
        customer_id: null,
        response: null,
        student_name :null,
        university:null,

        status: null,
      };
      this.$store.dispatch("initForm", form);
      if (val != null) {
        this.isNew = false;
        this.$store.dispatch("setForm", val);
      } else {
        this.isNew = true;
      }
      this.dialog_pay_form = true;
    },
  },
};
</script>
